import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';
import { Common } from 'ws-scripts/modules/common';
import { setClassNames } from 'ddc-classnames-js';
import { buildUrlWithParams } from '../helpers/utility';

class Cta extends React.Component {
	componentDidMount() {
		// Required to make the CTA button work on mobile
		const hasSlideIn =
			window.DDC && window.DDC.mobile && window.DDC.mobile.slidein;
		if (this.props.isMobile && hasSlideIn) {
			window.DDC.mobile.slidein.init();
		}
	}

	trackEvent() {
		this.props.trackGa({
			element: 'Share button',
			result: 'Opened share modal',
			widgetState: 'default'
		});
	}

	render() {
		const {
			btnStyle,
			href,
			icon = 'share-default',
			label,
			params,
			dialog,
			dialogTitle,
			dialogWidth,
			isMobile
		} = this.props;
		// Defined SVG data paths toggled by pref `ctaIcon1`
		const icons = {
			'share-default':
				'M14.5,9.8c-6,0-11.1,3.9-12.5,9.6l0,0c3.3-3.3,8-5,12.5-5l0,0v5L22,12l-7.5-7.5V9.8z',
			'share-thin':
				// eslint-disable-next-line max-len
				'M14,2.2l6.3,6.2c0.2,0.2,0.2,0.3,0.2,0.5c0,0.2-0.1,0.3-0.2,0.5L14,15.7c-0.3,0.3-0.7,0.3-0.9,0c-0.3-0.3-0.3-0.7,0-0.9l5.2-5.2h-6.2c-4,0-7.3,3.2-7.3,7.2l0,0.1V24H3.6v-7.1c0-4.7,3.7-8.4,8.4-8.5l0.1,0h6.2l-5.2-5.2c-0.3-0.3-0.3-0.7,0-0.9C13.4,1.9,13.8,1.9,14,2.2L14,2.2z'
		};
		const url = buildUrlWithParams(href, params);
		const dataAttributes = {
			'data-href': url,
			href: url
		};

		return (
			<Common
				render={({ labels }) => {
					if (dialog) {
						// On mobile if you omit data-title the slidein does not work.
						// We provide a backup in case the dialogTitle preference is blank.
						const labelAlias =
							dialogTitle === '' ? label : dialogTitle;
						dataAttributes['data-title'] = labels.get(labelAlias);
						dataAttributes.rel = 'nofollow';
						dataAttributes['data-width'] = dialogWidth;
					}

					return (
						<div
							className={setClassNames([
								'cta',
								!isMobile ? 'mr-4' : null
							])}
						>
							<Button
								className={setClassNames([
									'align-items-center',
									'd-flex',
									'btn',
									'btn-share',
									'btn-no-decoration',
									'btn-small',
									btnStyle,
									dialog ? 'dialog' : null,
									isMobile ? 'rounded-circle p-3 my-3' : null
								])}
								bsStyle={null}
								onClick={() => {
									this.trackEvent();
								}}
								{...dataAttributes}
							>
								{icon && icons[icon] !== undefined && (
									<svg
										version="1.1"
										xmlns="http://www.w3.org/2000/svg"
										width={20}
										height={20}
										viewBox="0 0 24 24"
										className="ddc-icon-vehicle-media-cta"
									>
										<path d={icons[icon]} />
									</svg>
								)}
								<span
									className={`pl-1${
										isMobile ? ' sr-only' : ''
									}`}
								>
									{labels.get(label)}
								</span>
							</Button>
						</div>
					);
				}}
			/>
		);
	}
}

Cta.propTypes = {
	btnStyle: PropTypes.string.isRequired,
	href: PropTypes.string.isRequired,
	icon: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
	params: PropTypes.shape({}),
	dialog: PropTypes.bool.isRequired,
	dialogTitle: PropTypes.string,
	dialogWidth: PropTypes.string,
	isMobile: PropTypes.bool.isRequired,
	trackGa: PropTypes.func.isRequired
};

Cta.defaultProps = {
	params: {},
	dialogTitle: '',
	dialogWidth: '300'
};

export default Cta;
